import { EntityDiagramActionFn, SetRenderWhiteLabeledAction } from '../types';

export const setRenderWhiteLabeledAction: EntityDiagramActionFn<
  SetRenderWhiteLabeledAction
> = (state, action) => {
  return {
    ...state,
    renderWhiteLabeled: action.renderWhiteLabeled,
  };
};
